import { Logout, Menu, Person } from '@mui/icons-material';
import { IconButton, List, ListItemButton, ListItemText, Popover, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userInfo } from '../../shared/utils';
import icon from '../../assets/images/icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import CustomLoading from '../../shared/CustomLoading';
import { profileGet } from '../../pages/myaccount/myAccount.api';
import HeaderNotifications from './HeaderNotifications';
import HeaderNotificationsProject from './HeaderNotificationsProject';
import Swal from 'sweetalert2';
import CustomModal from '../../shared/customModal/CustomModal';
import Mileage from '../../pages/account/component/Mileage';

export default function Header(props: { toggleExpand: any }) {
    const navigate = useNavigate();
    const dispatch = useDispatch<any>();

    const isMobile = useMediaQuery('(max-width:768px)');

    const { dataProfile } = useSelector((state: RootState) => state.myAccount);

    const [popAccount, setPopAccount] = useState<HTMLButtonElement | null>(null);

    useEffect(() => {
        dispatch(profileGet(userInfo().token));
    }, []);

    useEffect(() => {
        const showMobilePopup = userInfo().showMobilePopup;
        const isMultiRole = userInfo().user.roles.length > 1;
        const isFielder = userInfo().user.roles.some((role: string) => role === 'FielderSimple');

        if (showMobilePopup && isMobile && isMultiRole && isFielder) {
            Swal.fire({
                title: 'Select Option',
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: 'Manager View',
                denyButtonColor: '#063058',
                confirmButtonColor: '#ed6c02',
                confirmButtonText: 'Fielder View',
                showCloseButton: true,
                customClass: {
                    closeButton: 'swal-close-button'
                }
            }).then((result) => {
                if (result.isDenied) {
                    navigate('/dashboard');
                }

                if (result.isConfirmed) {
                    navigate('/fielding');
                }

                localStorage.setItem('fielderProUserAccount', JSON.stringify({ ...userInfo(), showMobilePopup: false }));
            });
        }
    }, [userInfo]);

    const handleLogout = async () => {
        await localStorage.removeItem('fielderProData');
        await localStorage.removeItem('fielderProAccount');
        await localStorage.removeItem('fielderProUserData');
        await localStorage.removeItem('fielderProUserAccount');
        await localStorage.removeItem('mileagePopup');
        window.location.href = '/signin';
    };

    return (
        <header>
            <CustomLoading />
            <Popover
                open={Boolean(popAccount)}
                anchorEl={popAccount}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => setPopAccount(null)}
                onClick={() => setPopAccount(null)}
            >
                <List>
                    <ListItemButton onClick={() => navigate('/myaccount')}>
                        <ListItemText primary="My Account" />
                    </ListItemButton>
                    <ListItemButton onClick={handleLogout}>
                        <ListItemText primary="Logout" />
                        <Logout color="primary" />
                    </ListItemButton>
                </List>
            </Popover>
            <div className="brand">
                <IconButton onClick={props.toggleExpand}>
                    <Menu />
                </IconButton>
                <img src={icon} alt="icon" />
                <span>Fielder Pro</span>
            </div>
            <div className="profile">
                <div>
                    <Typography variant="caption">{dataProfile.email}</Typography>
                    <IconButton color="inherit" onClick={(e) => setPopAccount(e.currentTarget)}>
                        <Person />
                    </IconButton>
                    {window.location.hash === '#/fielding' ? <HeaderNotifications /> : <HeaderNotificationsProject />}
                </div>
            </div>
        </header>
    );
}
